module.exports = __webpack_public_path__ + "img/top-banner-image.01a3e54e.png";